var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ path: _vm.itemURL }}},[_c('i',{class:_vm.itemIconClass}),_vm._v(" "+_vm._s(_vm.itemDisplayValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }